/**
 * @file store mutations
 * @author zhangzhimeng
 */
export default {
  // 导航树信息
  columnTreeList: [],
  // 用户信息
  user: null,
  token: '',
  // 按钮权限参数
  buttonPermissionList: [],
  activeIndex: '',
  columnItem: [],
  columnItemParent: {},
  activeChildrenIndex: '',
  contentId: '',
  specialInfo: {},
  footerList: []
}



// WEBPACK FOOTER //
// ./src/store/state.js